import React, { useState } from 'react';
import "../styles/StaffApply.css";

const PurchaseSupport = () => {
  const [formData, setFormData] = useState({
    name: '',
    discord: '',
    orderID: '',
    issueDescription: '',
  });
  const [successMsg, setSuccessMsg] = useState('');

  const handleChange = e => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const webhookURL = 'https://discord.com/api/webhooks/1375127690507714712/sCuuyAcYkpXtNSBwTipebcNQnYcfxmEbA-SmYuNmlXZ_LBbtQOpw8KpGwaImcJtRYaL6';

    const payload = {
      username: "RixxyMC Bot",
      embeds: [
        {
          title: "💳 Purchase Support Request",
          color: 3447003, // blue-ish
          fields: [
            { name: "👤 Minecraft Username", value: formData.name },
            { name: "💬 Discord Tag", value: formData.discord },
            { name: "🆔 Order ID", value: formData.orderID },
            { name: "❓ Issue Description", value: formData.issueDescription },
          ],
          footer: { text: "RixxyMC Purchase Support System" },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const response = await fetch(webhookURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSuccessMsg("✅ Support request sent successfully!");
        setFormData({ name: '', discord: '', orderID: '', issueDescription: '' });
      } else {
        setSuccessMsg("❌ Failed to send. Check webhook URL.");
      }
    } catch (err) {
      console.error(err);
      setSuccessMsg("❌ Error sending support request.");
    }
  };

  return (
    <div className="container">
      <h2>RixxyMC Purchase Support</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Minecraft Username:</label>
        <input id="name" type="text" value={formData.name} onChange={handleChange} required />

        <label htmlFor="discord">Discord Tag (e.g. user#1234):</label>
        <input id="discord" type="text" value={formData.discord} onChange={handleChange} required />

        <label htmlFor="orderID">Order ID:</label>
        <input id="orderID" type="text" value={formData.orderID} onChange={handleChange} required />

        <label htmlFor="issueDescription">Issue Description:</label>
        <textarea id="issueDescription" rows="4" value={formData.issueDescription} onChange={handleChange} required />

        <button type="submit">Submit Support Request</button>
        {successMsg && <div className="success">{successMsg}</div>}
      </form>
    </div>
  );
};

export default PurchaseSupport;
